import {mapGetters} from 'vuex'

let isLoaded = false

export default {
  name: 'BaseStore',
  computed: {
    ...mapGetters({
      userToken: 'Profile/token',
      userName: 'Profile/realName',
      isAdmin: 'Profile/isAdmin',
      auditAuth: 'Profile/auditAuth',
      navList: 'Profile/navList',
      loadStatus: 'LoadStatus/status',
      siteCategories: 'SiteCategory/list',
      siteCategoryMap: 'SiteCategory/map',
      deviceCategories: 'DeviceCategory/list',
      deviceCategoryMap: 'DeviceCategory/map',
      devices: 'Device/list',
      deviceMap: 'Device/map',
      deviceCategoryIdMap: 'Device/categoryMap',
      factorGroups: 'FactorGroup/list',
      factorGroupMap: 'FactorGroup/map',
      factors: 'Factor/list',
      factorMap: 'Factor/map',
      relatedFactorMap: 'RelatedFactor/map',
      profileSites: 'Profile/sites',
      _profileSiteDevices: 'Profile/siteDevices',
      auditRuleFlagMap: 'AuditRule/flagMap',
      lastSelectIds: 'AuditSelectSite/lastSelectIds',
      defaultExpandedKeys: 'AuditSelectSite/defaultExpandedKeys',
      defaultCheckedKeys: 'AuditSelectSite/defaultCheckedKeys',
      showSideNav: 'Profile/showSideNav'
    }),
    profileSiteMap () {
      return this.profileSites.reduce((map, site) => {
        map[site.id] = site
        return map
      }, {})
    },
    profileSiteDevices () {
      return this._profileSiteDevices
    },
    profileSiteDeviceMap () {
      return this._profileSiteDevices.reduce((map, siteDevice) => {
        map[siteDevice.id] = siteDevice
        return map
      }, {})
    },
    gutter: () => 20
  },
  methods: {
    changeLoadStatus (status) {
      this.$store.commit('LoadStatus/status', status)
    }
  },
  created () {
    if (isLoaded) {
      return
    }

    if (!this.userName) {
      return
    }

    let {$store} = this

    $store.dispatch('FactorGroup/request').then(() => {
      $store.dispatch('Factor/request').then(() => {
        $store.dispatch('AuditRule/request').then(() => {
          $store.dispatch('EnvFactor/request')
          $store.dispatch('SiteCategory/request')
          $store.dispatch('Profile/requestSiteInfos')
          $store.dispatch('DeviceCategory/request')
          $store.dispatch('Device/request')
        })
      })
    })

    isLoaded = true
  }
}



// WEBPACK FOOTER //
// ./src/components/BaseStore.js